import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// ============================================================
// 图标与字体：改为本地打包，不再依赖 fonts.googleapis.com
// ============================================================
// 原先这两样都是从 Google Fonts 加载的：
//   <link href="https://fonts.googleapis.com/icon?family=Material+Icons">
//   <link href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans...">
//
// 问题在于 fonts.googleapis.com 在中国大陆不可达。后果比"字体变丑"严重得多：
// 全站的 <span className="material-icons"> 会退化成显示英文字面量
// （界面上会出现 "arrow_back"、"photo_camera" 这样的文字），而样式和接口都正常。
//
// 现在改为随构建打包，离线/断外网都能正常显示。
//
// ⚠️ 必须在 './index.css' 之前导入：
//    图标 CSS 定义了 .material-icons 的默认字号（24px）等属性，
//    而 Tailwind 的工具类（如 text-[28px]、!text-3xl）在 index.css 末尾输出，
//    顺序反了工具类就会被图标默认值覆盖。
//
// 体积说明（实测优化）：
//   - 用 filled.css 而不是 material-icons.css：后者把 outlined/round/sharp/two-tone
//     四种变体的 @font-face 也一起打进来，构建产物会多出约 1.6 MB 字体，
//     而本项目只用 .material-icons（filled）一种。
//   - 用 latin-*.css 而不是 400.css：后者会额外打包 vietnamese 与 latin-ext 子集，
//     本应用界面是中文 + 英文，中文字形走系统字体，只需 latin 子集。
import 'material-icons/iconfont/filled.css';
import '@fontsource/plus-jakarta-sans/latin-400.css';
import '@fontsource/plus-jakarta-sans/latin-500.css';
import '@fontsource/plus-jakarta-sans/latin-600.css';
import '@fontsource/plus-jakarta-sans/latin-700.css';

import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
